import React from "react";
import PagesTop from "../../components/Frontend/PagesTop";
import Plans from "../../components/Frontend/Plans";
import HomePageLayout from "../../layouts/HomepageLayout";
import "../../styles/Frontend/pages.scss";
import planBg from "../../styles/bgs/asset 23.jpeg";

const Plan = () => {
  return (
    <HomePageLayout>
      <PagesTop title="INVESTMENT PLANS" link="Plans" bg={planBg} />
      {/* <Plans /> */}

      <>
        <section className="plans">
          <div className="container inner">
            <div className="section-title">
              <h1 className="fw-bold">Our Amazing Plans</h1>
              <p>
                To make a solid investment, you have to know where you are
                investing. Find a plan which is best for you.
              </p>
            </div>
            <Plans />
          </div>
        </section>
      </>
    </HomePageLayout>
  );
};

export default Plan;
